export const search_Logo = "https://icons.veryicon.com/png/o/miscellaneous/monochrome-icon-1/search-521.png"

export const BG_Image = "https://cdn.grofers.com/cdn-cgi/image/f=auto,fit=scale-down,q=70,metadata=none,w=2700/layout-engine/2022-05/Group-33704.jpg"

export const Shop_Logo = "https://www.creativefabrica.com/wp-content/uploads/2021/01/21/Shop-Logo-Graphics-7955312-1-1-580x387.jpg"